import { requestNotificationPermission, onMessageListener } from '../firebase/config';
import { toast } from 'react-toastify';

class NotificationService {
  constructor() {
    this.token = null;
    this.isSupported = 'Notification' in window && 'serviceWorker' in navigator;
  }

  async initialize() {
    if (!this.isSupported) {
      console.warn('This browser does not support notifications or service workers');
      return false;
    }

    try {
      // Check if permission is already granted
      if (Notification.permission === 'granted') {
        // Register service worker
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        console.log('Service Worker registered with scope:', registration.scope);

        // Get existing token or request new one
        this.token = await requestNotificationPermission();

        if (this.token) {
          console.log('Push notification token:', this.token);

          // Send token to your server
          await this.sendTokenToServer(this.token);

          // Listen for foreground messages
          this.listenForMessages();

          return true;
        }
      } else {
        // Permission not granted, request it
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        console.log('Service Worker registered with scope:', registration.scope);

        this.token = await requestNotificationPermission();

        if (this.token) {
          console.log('Push notification token:', this.token);
          await this.sendTokenToServer(this.token);
          this.listenForMessages();
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error('Error initializing notifications:', error);
      return false;
    }
  }

  async sendTokenToServer(token) {
    // No backend - just store locally for admin reference
    console.log('No backend configured. Storing token locally.');
    console.log('FCM Token for admin use:', token);

    localStorage.setItem('fcm_token', token);
    localStorage.setItem('fcm_token_timestamp', new Date().toISOString());
    localStorage.setItem('user_id', this.getCurrentUserId());

    // Display token in console for easy copying
    console.log('🔔 Copy this token for Firebase Console notifications:');
    console.log(token);
  }

  getCurrentUserId() {
    // Implement your user identification logic here
    // This could be from localStorage, Redux state, or your auth system
    return localStorage.getItem('user_id') || 'anonymous';
  }

  listenForMessages() {
    onMessageListener()
      .then((payload) => {
        console.log('Received foreground message:', payload);

        // Show toast notification for foreground messages
        toast.info(
          `${payload.notification.title}: ${payload.notification.body}`,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      })
      .catch((error) => {
        console.error('Error listening for messages:', error);
      });
  }

  getToken() {
    return this.token;
  }

  isNotificationSupported() {
    return this.isSupported;
  }

  getPermissionStatus() {
    if (!this.isSupported) return 'not-supported';
    return Notification.permission;
  }
}

export default new NotificationService();